import { render, staticRenderFns } from "./UpdateLeadExtra.vue?vue&type=template&id=231fe649"
import script from "./UpdateLeadExtra.vue?vue&type=script&lang=js"
export * from "./UpdateLeadExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports